import {
  LOAD_SUBTEAMS_LIST,
  SET_SUBTEAMS_LIST,
  ADDING_NEW_SUBTEAM,
  SET_NEW_SUBTEAM,
  UPDATE_SUBTEAM,
  REMOVING_SUBTEAM,
  REMOVE_SUBTEAM_FROM_LIST,
  REMOVE_USER_FROM_SUBTEAM
} from '@/state/mutationTypes'

export default {
  [LOAD_SUBTEAMS_LIST](state, payload) {
    state.loadTeamsList = payload
  },
  [SET_SUBTEAMS_LIST](state, payload) {
    state.teamsList = [...payload]
  },
  [ADDING_NEW_SUBTEAM](state, payload) {
    state.addingNewTeam = payload
  },
  [SET_NEW_SUBTEAM](state, payload) {
    let teamsList = state.teamsList
    teamsList = [...teamsList, payload]
    state.teamsList = [...teamsList]
  },
  [UPDATE_SUBTEAM](state, payload) {
    let teamsList = state.teamsList
    let subTeamIndex = teamsList.findIndex(
      team => parseInt(team.id) === parseInt(payload.id)
    )
    teamsList[subTeamIndex].name = payload.name
    state.teamsList = [...teamsList]
  },
  [REMOVING_SUBTEAM](state, payload) {
    state.removingTeam = payload
  },
  [REMOVE_SUBTEAM_FROM_LIST](state, payload) {
    let teamsList = state.teamsList
    teamsList = teamsList.filter(
      team => parseInt(team.id) !== parseInt(payload)
    )
    state.teamsList = [...teamsList]
  },
  [REMOVE_USER_FROM_SUBTEAM](state, payload) {
    let teamsList = state.teamsList
    let teamIndex = teamsList.findIndex(
      team => parseInt(team.id) === parseInt(payload.subTeamId)
    )
    let teamUsers = teamsList[teamIndex].users
    teamUsers = teamUsers.filter(
      user => parseInt(user.id) !== parseInt(payload.userId)
    )
    teamsList[teamIndex].users = [...teamUsers]
    state.teamsList = [...teamsList]
  }
}
